import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_02a39e4a from 'nuxt_plugin_plugin_02a39e4a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_1566b7b2 from 'nuxt_plugin_plugin_1566b7b2' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_axios_9c4d2f40 from 'nuxt_plugin_axios_9c4d2f40' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_persistedState_1da1c1a3 from 'nuxt_plugin_persistedState_1da1c1a3' // Source: ../plugins/persistedState.js (mode: 'all')
import nuxt_plugin_vueinfiniteloading_5f280597 from 'nuxt_plugin_vueinfiniteloading_5f280597' // Source: ../plugins/vue-infinite-loading.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_vue2touchevents_147d6945 from 'nuxt_plugin_vue2touchevents_147d6945' // Source: ../plugins/vue2-touch-events.js (mode: 'all')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../plugins/swiper.js (mode: 'client')
import nuxt_plugin_vcalendar_4dbed36c from 'nuxt_plugin_vcalendar_4dbed36c' // Source: ../plugins/v-calendar.js (mode: 'client')
import nuxt_plugin_vueconcisecarousel_42efebf2 from 'nuxt_plugin_vueconcisecarousel_42efebf2' // Source: ../plugins/vue-concise-carousel.js (mode: 'client')
import nuxt_plugin_aos_78651e70 from 'nuxt_plugin_aos_78651e70' // Source: ../plugins/aos.js (mode: 'client')
import nuxt_plugin_initpositions_2114d634 from 'nuxt_plugin_initpositions_2114d634' // Source: ../plugins/init-positions.js (mode: 'client')
import nuxt_plugin_position_8e2b3a10 from 'nuxt_plugin_position_8e2b3a10' // Source: ../plugins/position.js (mode: 'all')
import nuxt_plugin_auth_5c0bb4d0 from 'nuxt_plugin_auth_5c0bb4d0' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_meta_56c65178 from 'nuxt_plugin_meta_56c65178' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - 자유마을","title":"자유마을","htmlAttrs":{"lang":"kr"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fd2d5wqehjh5x7e.cloudfront.net\u002F23247\u002FKakaoTalk_Photo_2024-02-29-20-40-43.png"},{"hid":"og:title","property":"og:title","content":"자유마을 - 3506개의 희망"},{"hid":"og:description","property":"og:description","content":"대한민국세력은 하나로 함께"}],"link":[{"rel":"stylesheet","href":"https:\u002F\u002Fgcore.jsdelivr.net\u002Fnpm\u002Fxeicon@2.3.3\u002Fxeicon.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","type":"image\u002Fx-icon","href":"\u002Fimages\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fimages\u002Fandroid-chrome-192x192.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fimages\u002Fandroid-chrome-512x512.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fimages\u002Ffavicon-16x16.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fimages\u002Ffavicon-32x32.png"}],"script":[{"src":"\u002F\u002Ft1.daumcdn.net\u002Fmapjsapi\u002Fbundle\u002Fpostcode\u002Fprod\u002Fpostcode.v2.js"},{"src":"\u002F\u002Fdapi.kakao.com\u002Fv2\u002Fmaps\u002Fsdk.js?autoload=false&appkey=0b676e15765c46418fa53c1333910c0a&libraries=services,clusterer"},{"src":"\u002F\u002Fdevelopers.kakao.com\u002Fsdk\u002Fjs\u002Fkakao.min.js"},{"src":"\u002F\u002Fajax.googleapis.com\u002Fajax\u002Flibs\u002Fjquery\u002F3.5.1\u002Fjquery.min.js"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-V3S8X6G5GD","async":true},{"src":"\u002Fjs\u002Fanalytics.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_02a39e4a === 'function') {
    await nuxt_plugin_plugin_02a39e4a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_1566b7b2 === 'function') {
    await nuxt_plugin_plugin_1566b7b2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_9c4d2f40 === 'function') {
    await nuxt_plugin_axios_9c4d2f40(app.context, inject)
  }

  if (typeof nuxt_plugin_persistedState_1da1c1a3 === 'function') {
    await nuxt_plugin_persistedState_1da1c1a3(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinfiniteloading_5f280597 === 'function') {
    await nuxt_plugin_vueinfiniteloading_5f280597(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2touchevents_147d6945 === 'function') {
    await nuxt_plugin_vue2touchevents_147d6945(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_4dbed36c === 'function') {
    await nuxt_plugin_vcalendar_4dbed36c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueconcisecarousel_42efebf2 === 'function') {
    await nuxt_plugin_vueconcisecarousel_42efebf2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_78651e70 === 'function') {
    await nuxt_plugin_aos_78651e70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initpositions_2114d634 === 'function') {
    await nuxt_plugin_initpositions_2114d634(app.context, inject)
  }

  if (typeof nuxt_plugin_position_8e2b3a10 === 'function') {
    await nuxt_plugin_position_8e2b3a10(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_5c0bb4d0 === 'function') {
    await nuxt_plugin_auth_5c0bb4d0(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_56c65178 === 'function') {
    await nuxt_plugin_meta_56c65178(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
